module.exports = __webpack_public_path__ + "static/img/person-using-black-and-white-smartphone-and-holding-blue-230544.24de159c.jpg";